import React from 'react';
import { Box, Typography, Tooltip } from '@mui/material';
import { formatDuration } from '../utils/format';

// Two-segment bar: green for worked (active) time, red for idle time,
// each proportional to their share of total tracked time (worked + idle).
export default function IdleBar({ idle = 0, worked = 0, sx }) {
    const total = idle + worked;
    const workedPct = total > 0 ? (worked / total) * 100 : 0;
    const idlePct = total > 0 ? (idle / total) * 100 : 0;

    return (
        <Box sx={{ minWidth: 140, ...sx }}>
            <Box sx={{ display: 'flex', height: 8, borderRadius: 999, overflow: 'hidden', bgcolor: 'rgba(255,255,255,0.06)' }}>
                {total === 0 ? null : (
                    <>
                        {workedPct > 0 && (
                            <Tooltip title={`Worked: ${formatDuration(worked)} (${Math.round(workedPct)}%)`} arrow>
                                <Box sx={{ width: `${workedPct}%`, bgcolor: '#10B981', height: '100%' }} />
                            </Tooltip>
                        )}
                        {idlePct > 0 && (
                            <Tooltip title={`Idle: ${formatDuration(idle)} (${Math.round(idlePct)}%)`} arrow>
                                <Box sx={{ width: `${idlePct}%`, bgcolor: '#EF4444', height: '100%' }} />
                            </Tooltip>
                        )}
                    </>
                )}
            </Box>
            <Typography variant="caption" color="text.secondary" sx={{ mt: 0.5, display: 'block' }}>
                {total > 0 ? `${formatDuration(idle)} idle (${Math.round(idlePct)}%)` : 'No activity'}
            </Typography>
        </Box>
    );
}
